var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconThumbsUpFillComponent(props, ref) {
    var prefixFromContext = useContext(Context).prefix;
    var _a = props.className, className = _a === void 0 ? '' : _a, prefixFromProps = props.prefix, _b = props.width, width = _b === void 0 ? '1em' : _b, _c = props.height, height = _c === void 0 ? '1em' : _c, _d = props.useCurrentColor, useCurrentColor = _d === void 0 ? true : _d, spin = props.spin, rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor", "spin"]);
    var prefix = prefixFromProps || prefixFromContext || 'arco';
    var loadingKls = spin ? " ".concat(prefix, "-icon-loading") : '';
    return React.createElement("svg", __assign({ className: "".concat(prefix, "-icon ").concat(prefix, "-icon-thumbs_up_fill").concat(loadingKls, " ").concat(className), width: width, height: height, viewBox: "0 0 16 16", fill: useCurrentColor ? 'currentColor' : '#000', xmlns: "http://www.w3.org/2000/svg" }, rest, { ref: ref }),
        React.createElement("path", { d: "M10.0158 5.71152V3.38196C10.0158 2.70107 9.65393 2.10507 9.11284 1.77743 8.58715 1.45911 7.99131 1.76993 7.74201 2.33336L5.33341 6.83336 5.33353 14.1666C5.33353 14.2587 5.40815 14.3333 5.5002 14.3333H12.5528C13.1723 14.3403 13.7024 13.8877 13.7953 13.2724L14.6527 7.31352C14.7074 6.95146 14.601 6.58358 14.3618 6.30723 14.1226 6.03091 13.7746 5.87403 13.4101 5.87819H10.1825C10.0904 5.87819 10.0158 5.80357 10.0158 5.71152zM4.16664 6.81104C4.25868 6.81104 4.3333 6.88566 4.3333 6.9777L4.33341 14.1661C4.33341 14.2582 4.25882 14.3328 4.16679 14.3328L3.06976 14.3331C2.36435 14.3459 1.76132 13.8162 1.66675 13.1007V8.11169C1.76132 7.39622 2.36435 6.79827 3.06976 6.81104H4.16664z", fillOpacity: "1" }));
}
var IconThumbsUpFill = React.forwardRef(IconThumbsUpFillComponent);
export default IconThumbsUpFill;
